import { SignIn as ClerkSignIn } from "@clerk/clerk-react";

export default function SignIn() {
	return (
		<main className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
			<div className="text-center mb-6 absolute top-8 left-1/2 -translate-x-1/2">
				<a
					href="/"
					className="flex items-center gap-2 hover:opacity-80 transition justify-center"
				>
					<span className="text-2xl">✂️</span>
					<span className="font-bold text-lg text-gray-900">しろぬきや</span>
				</a>
			</div>
			<ClerkSignIn routing="path" path="/sign-in" signUpUrl="/sign-up" />
		</main>
	);
}
